<template>
    <b-modal :no-close-on-backdrop="true" size="md" :title="$t('create_new_vendor')" ref="innermodal">
        <div class="row">
            <div class="col-sm-12">
                <div class="flex-container">
                    <div>
                        <input type="file" ref="file" @change="fileChangeHandler" accept="image/*" style="display:none;"/>
                        <img :src="img" alt="" class="img-thumbnail" style="width: 135px;" @click="$refs.file.click()">
                    </div>
                    <div class="flex-right">
                        <div class="form-group" :class="{ 'form-group-error': $v.model.Name.$error }">
                            <label class="blue label-control">{{$t('name')}}</label>
                            <div>
                                <input type="text" class="form-control form-control-sm" v-model="$v.model.Name.$model" />
                            </div>
                        </div>
                        <div class="form-group">
						<label class="label-control blue">VAT TIN</label>
						<div>
						<div class="row">
							<div class="col-sm-4 col-lg-4">
							<input type="text" class="form-control form-control-sm" v-model="model.TinHead"/>
							</div>
							<div class="col-sm-8 col-lg-8">
							<b-form-input class="form-control-sm" v-model="model.VatTin"/>
							</div>
						</div>
						</div>
					</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label class="blue label-control">{{$t('latin_name')}}</label>
            <div>
                <input type="text" class="form-control form-control-sm" v-model="model.NameEng" />
            </div>
        </div>
        <div class="row">
             <div class="col-sm-6">
                <div class="form-group" :class="{ 'form-group-error': $v.model.Phone.$error }">
                    <label class="blue label-control">{{$t('phone')}}</label>
                    <div>
                        <input type="text" class="form-control form-control-sm" v-model="$v.model.Phone.$model" />
                    </div>
                </div>
            </div>
             <div class="col-sm-6">
                <div class="form-group">
                    <label class="blue label-control">{{$t('email')}}</label>
                    <div><input type="text" class="form-control form-control-sm" v-model="model.Email" /></div>
                </div>
            </div>
        </div>
        <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                    <label class="blue label-control">{{$t('website')}}</label>
                    <div><input type="text" class="form-control form-control-sm" v-model="model.Website" /></div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="label-control blue">{{ $t('capital') }}</label>
                    <div>
                        <select class="form-control form-control-sm" v-model="model.CapitalId">
                            <option value="">Not Set</option>
                            <option v-for="ret in capitals" :key="ret.Id" :value="ret.Id">{{ret.Code + ':' + ret.Name}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label class="blue label-control">{{$t('address')}}</label>
            <div><input type="text" class="form-control form-control-sm" v-model="model.Address" /></div>
        </div>
        <div slot="modal-footer">
            <b-btn variant="primary" size="sm" @click="clickSaveHandler"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn>
        </div>
    </b-modal>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
export default {
    props: {
        name: { type: String, default: '' }
    },
    data: function() {
        return {
            model: {
                Name: '',
                Phone: ''
            },
            capitals: [],
            actionLink: 'vendor/save',
            img: '/img/no-image.svg',
            formHead: { headers: { 'Content-Type': 'multipart/form-data' }}
        }
    },
    validations:{
        model: {
            Name: { required },
            Phone: { required }
        }
    },
    created: function(){
        if(this.value !== undefined){
            this.model = this.value;
        }
        this.capitalList();
    },
    methods: {
        clickSaveHandler: function() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                let loading = this.$loading.show();
                let formData = new FormData();
                formData.append('File', this.$refs.file.files[0]);
                for (let p in this.model) {
                let val = this.model[p];
                if(val != null)
                    formData.append(p, val);
                }
                formData.append('CompanyId', this.$store.state.company.Id);
                formData.append('ClientId', this.$store.state.company.ClientId);

                this.$api().post(this.actionLink, formData, this.formHead).then(res => {
                    if (this.$isValid(res)) {
                            var vendor = res.data.Json.Vendor;
                            this.$emit('done', vendor);
                            this.model = {
                                Name: '',
                                Phone: ''
                            };
                            this.$v.$reset();
                            this.$refs.innermodal.hide();
                    }
                }).finally(() => { loading.hide(); });
            }
		},
        fileChangeHandler: function(e){
            const file = e.target.files[0];
            this.img = URL.createObjectURL(file);
        },
		async capitalList(){
            let res = await this.$api().post('location/capitals');
			if(this.$isValid(res)){
				this.capitals = res.data.Json.Capitals;
			}
		}
    },
    watch: {
        name(value){
            this.$v.$reset();
            this.model.Name = value;

        }
    }
}
</script>
